import { Machine } from "xstate";

const subscriptionDetailListMachine = Machine({
  id: "subscriptionDetailList",
  initial: "idle",
  states: {
    idle: {
      on: {
        RELOAD: "loading",
      },
    },
    loading: {
      on: {
        RESOLVE: "idle",
        REJECT: "error",
      },
    },
    error: {
      type: "final",
    },
  },
});

export default subscriptionDetailListMachine;
